<template>
  <c-card-base
    :item="item"
    :small="small"
    :highlighted="highlighted"
    :hover="hover"
  >
    <template #top>
      <p
        v-if="item.Effect && item.Effect.length"
        v-html-safe="item.Effect"
        class="card-effect pa-2 mb-1"
        style="font-size: 15px"
      />
    </template>
    <template #overline>
      <span>{{ item.Type }}</span>
    </template>
  </c-card-base>
</template>

<script lang="ts">
  import CCardBase from './_cCardBase.vue'
  export default {
    name: 'FrameCardContent',
    components: { CCardBase },
    props: {
      item: { type: Object, required: true },
      small: { type: Boolean },
      hover: { type: Boolean },
      highlighted: { type: Boolean },
    },
  }
</script>

<style scoped>
  .card-effect {
    max-height: 75px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;

    -webkit-line-clamp: 3;
  }
</style>
